/**
 * AI:
 * Status: 'in progress'
 * Type: Component
 * SubType: ObjectBaseModeComponent
 * Reason: Side (drawer) view of the lg.LogicMappingTable object component — the same four sections in a
 *         compact cut; the drawer host renders the navigation rail from the emitted items.
 */
import {Component, OnInit} from '@angular/core';
import {LgLogicMappingTableObjectBaseComponent} from '../lg-logic-mapping-table-object-base.component';

/**
 * Compact view of the mapping-table object component, used when the table is opened in the right-hand
 * drawer instead of on its own page.
 *
 * Same four sections as the full view, but the long withdrawal explanation is not repeated here — it
 * belongs to the page where a table is actually retired. The drawer keeps the fallback warning, because
 * that one is a data defect the user must see wherever the table appears.
 *
 * Unlike the full view this one DOES emit its navigation items: in the drawer the host (`mvs-object`)
 * draws the rail.
 */
@Component({
    selector: 'mvs-lg-logic-mapping-table-object-component-side',
    templateUrl: 'lg-logic-mapping-table-object-side.component.html',
    styleUrls: ['lg-logic-mapping-table-object-side.component.scss'],
    standalone: false
})
export class LgLogicMappingTableObjectSideComponent extends LgLogicMappingTableObjectBaseComponent implements OnInit {

    override loadSideBarMenuItems(): void {
        this.navigationItems = [
            {
                label: 'Übersicht',
                action: LgLogicMappingTableObjectBaseComponent.NAV_OVERVIEW,
                tooltip: 'Stammdaten und Fallback-Verhalten',
                icon: 'fa-regular fa-circle-info',
                toggleable: false,
                default: true
            },
            {
                label: 'Einträge',
                action: LgLogicMappingTableObjectBaseComponent.NAV_ENTRIES,
                tooltip: 'Zuordnungen von Quellwert auf Zielwert',
                icon: 'fa-regular fa-list',
                toggleable: false,
                default: false
            },
            {
                label: 'Overrides',
                action: LgLogicMappingTableObjectBaseComponent.NAV_OVERRIDES,
                tooltip: 'Partnerspezifische Zuordnungen',
                icon: 'fa-regular fa-user-gear',
                toggleable: false,
                default: false
            },
            {
                label: 'Schnelltest',
                action: LgLogicMappingTableObjectBaseComponent.NAV_QUICK_TEST,
                tooltip: 'Einen Quellwert gegen diese Tabelle auflösen',
                icon: 'fa-regular fa-gauge-high',
                toggleable: false,
                default: false
            }
        ];

        this.activeNavigationItem = this.navigationItems[0];
        this.handleNavigationItemsChange();
    }

}
